import { LinkButton } from "$components/button/link-button";
import { ElephantLogoIcon } from "$components/icons";
import { Page } from "$components/page";
import PageContent from "$components/page/page-content";
import { linkToHome } from "$routes/_lib/links";
import { styled, Typography } from "@material-ui/core";

const Content = styled(PageContent)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(4),
  alignItems: "center",
}));

export const NotFoundPage = () => (
  <Page data-testid="404-page">
    <Content>
      <ElephantLogoIcon />
      <Typography variant="h1">{"Page not found"}</Typography>
      <LinkButton to={linkToHome()}>{"Return home"}</LinkButton>
    </Content>
  </Page>
);
